<template>
  <div>
    <template v-if="type === 'radio'">
      <b-form-radio-group
          v-model="CHECKOUT_DATA[modelKey]['S_'+serviceOption.id]"
          @input="input"
      >
        <div>
          <h2 v-if="showTitle" class="text-primary font-medium-1 mt-2">{{ serviceOption.description }}</h2>
          <div>
            <div v-for="serviceItem in serviceOption.children" :key="serviceItem.id">
              <b-form-radio name="test" :value="[serviceItem]">
                <service-option-item-text
                    :service-option-item="serviceItem"
                    :product-dependencies="SERVICE.serviceOptionsDependencies"
                    :additional-text="additionalText"
                    :add-minimum-term-period="addMinimumTermPeriod"
                />
              </b-form-radio>
            </div>
          </div>
        </div>
      </b-form-radio-group>
      <template v-if="(resetButton && (!hideResetButton))">
        <b-button variant="primary" size="sm" class="mt-1" @click="resetRadio()">Auswahl aufheben</b-button>
      </template>
    </template>
    <template v-else>
      <b-form-checkbox-group
          v-model="CHECKOUT_DATA[modelKey]['S_'+serviceOption.id]"
          @input="input"
      >
        <div>
          <h2 v-if="showTitle" class="text-primary font-medium-1 mt-2">{{ serviceOption.description }}</h2>
          <div>
            <div v-for="serviceItem in serviceOption.children" :key="serviceItem.id">
              <b-form-checkbox :value="serviceItem">
                <service-option-item-text
                    :service-option-item="serviceItem"
                    :product-dependencies="SERVICE.serviceOptionsDependencies"
                    :additional-text="additionalText"
                    :add-minimum-term-period="addMinimumTermPeriod"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </b-form-checkbox-group>
    </template>
  </div>
</template>

<script>
import ServiceOptionItemText from "@/components/ServiceOptionItemText";
import {BFormCheckbox, BFormCheckboxGroup, BFormRadio, BFormRadioGroup} from "bootstrap-vue";
import {mapGetters} from "vuex";
import Vue from "vue";

export default {
  name: "ServiceOptionsGroup",
  components: {
    BFormRadioGroup,
    BFormRadio,
    BFormCheckboxGroup,
    BFormCheckbox,
    ServiceOptionItemText
  },
  props: {
    serviceOption: {
      type: Object,
      default: null,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    showPricePrimary: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'checkbox'
    },
    modelKey: {
      type: String,
      default: null,
      required: true,
    },
    resetButton: {
      type: Boolean,
      default: false,
    },
    additionalText: {
      type: String,
      default: ''
    },
    addMinimumTermPeriod: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  data() {
    return {
      hideResetButton: false,
    }
  },
  methods: {
    input() {
      this.$nextTick(()=> {
        this.$emit('input')
      })

      this.hideResetButton = false
    },
    resetRadio() {
      this.CHECKOUT_DATA[this.modelKey]['S_'+this.serviceOption.id] = []
      // console.log(this.modelKey)
      // this.$store.commit('RESET_OPTION', this.modelKey)
      // console.log(this.CHECKOUT_DATA)
      // Vue.set(this.CHECKOUT_DATA[this.modelKey], id, {});

      this.$nextTick(()=> {
        this.hideResetButton = true

        this.$emit('input')
      })
    },
  },
  mounted() {
    if (typeof this.CHECKOUT_DATA[this.modelKey]["S_"+this.serviceOption.id] === 'object') {
      if (Array.isArray(this.CHECKOUT_DATA[this.modelKey]["S_"+this.serviceOption.id]) && this.CHECKOUT_DATA[this.modelKey]["S_"+this.serviceOption.id].length === 0) {
        this.hideResetButton = true
      } else {
        this.hideResetButton = false
      }
    } else {
      this.hideResetButton = true
    }
  }
}
</script>

<style scoped>

</style>
